import { render, staticRenderFns } from "./CommodityOrderDialog.vue?vue&type=template&id=468f9029&scoped=true&"
import script from "./CommodityOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CommodityOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommodityOrderDialog.vue?vue&type=style&index=0&id=468f9029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f9029",
  null
  
)

/* custom blocks */
import block0 from "./CommodityOrderDialog.vue?vue&type=custom&index=0&blockType=success-dialog&%3Ashow.sync=successShow&%3Atitle=successTitle&%3Amessage=successMessage&%3Ameta=successMeta"
if (typeof block0 === 'function') block0(component)

export default component.exports